// Prymitywy tabeli. Refine jest tu użyty bez warstwy UI (headless), więc
// tabelę rysujemy sami - dzięki temu panel wygląda jak reszta produktu,
// a nie jak zestaw komponentów z pudełka.

import type { ReactNode } from "react";

export function Table({ children }: { children: ReactNode }) {
  return (
    <div className="overflow-x-auto rounded-card border border-line bg-surface">
      <table className="w-full border-collapse text-left text-base">{children}</table>
    </div>
  );
}

/** Wiersz danych. Podświetlenie na hover ułatwia czytanie szerokich tabel. */
export function Tr({ children }: { children: ReactNode }) {
  return <tr className="transition-colors hover:bg-bg/60">{children}</tr>;
}

export function Th({ children, align }: { children: ReactNode; align?: "right" }) {
  return (
    <th
      scope="col"
      className={`border-b border-line px-3.5 py-2.75 font-medium text-ink-soft ${
        align === "right" ? "text-right" : ""
      }`}
    >
      {children}
    </th>
  );
}

export function Td({
  children,
  align,
  numeric,
  nowrap,
}: {
  children?: ReactNode;
  align?: "right";
  numeric?: boolean;
  nowrap?: boolean;
}) {
  return (
    <td
      className={`border-b border-line-soft px-3.5 py-2.75 align-top ${
        align === "right" ? "text-right" : ""
      } ${numeric ? "tabular" : ""} ${nowrap ? "whitespace-nowrap" : ""}`}
    >
      {children}
    </td>
  );
}

/** Drugi wiersz w komórce: pakiet, adres, identyfikator. */
export function Sub({ children }: { children: ReactNode }) {
  return <span className="mt-0.5 block text-xs text-ink-soft">{children}</span>;
}

export function EmptyRow({ colSpan, children }: { colSpan: number; children: ReactNode }) {
  return (
    <tr>
      <td colSpan={colSpan} className="px-3.5 py-10 text-center text-ink-soft">
        {children}
      </td>
    </tr>
  );
}
